/* import __COLOCATED_TEMPLATE__ from './fraction.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';

export default class Fraction extends Component {
  @service adiStyleService;

  forceXLargeDenominator = false;

  // Build the following behavior into a modifier
  // didInsertElement() {
  //   super.didInsertElement(...arguments);
  //   let numeratorElement = this.element.querySelector(`.${this.numeratorClassName}`);
  //   let denominatorElement = this.element.querySelector(`.${this.denominatorClassName}`);

  //   let addMinHeightStyle = (selectorClass, value, difference, options = {}) => {
  //     let properties = {};
  //     let fontSize = null;
  //     properties['min-height'] = `${value}px`;

  //     // Increase font-size for the increased size of div
  //     if (difference > 55 || options.forceXLarge) fontSize = 'x-large';
  //     else if (difference > 40) fontSize = 'large';
  //     else if (difference > 25) fontSize = 'medium';

  //     if (fontSize) properties['font-size'] = fontSize;

  //     this.adiStyleService.insertRule({
  //       selector: `#${this.elementId} > ${selectorClass}`,
  //       properties: properties,
  //     });
  //   };

  //   if (numeratorElement && denominatorElement) {
  //     if (numeratorElement.offsetHeight > denominatorElement.offsetHeight) {
  //       let options = {};
  //       if (this.forceXLargeDenominator) options.forceXLarge = true;
  //       addMinHeightStyle(
  //         `.${this.denominatorClassName}`,
  //         numeratorElement.offsetHeight,
  //         numeratorElement.offsetHeight - denominatorElement.offsetHeight,
  //         options
  //       );
  //     } else if (denominatorElement.offsetHeight > numeratorElement.offsetHeight) {
  //       addMinHeightStyle(
  //         `.${this.numeratorClassName}`,
  //         denominatorElement.offsetHeight,
  //         denominatorElement.offsetHeight - numeratorElement.offsetHeight
  //       );
  //     }
  //   }
  // }

  // didDestroyElement() {
  //   super.didDestroyElement();
  //   this.adiStyleService.removeRuleForSelectors([
  //     `#${this.elementId} > .${this.numeratorClassName}`,
  //     `#${this.elementId} > .${this.denominatorClassName}`,
  //     `#${this.elementId}`,
  //   ]);
  // }
}
